import { Component } from '@angular/core';

@Component({
  selector: 'app-mensagem-erro-input',
  templateUrl: './mensagem-erro-input.component.html',
  styleUrls: ['./mensagem-erro-input.component.scss']
})
export class MensagemErroInputComponent {}
